module.exports = __webpack_public_path__ + "img/sub8.e2e17eeb.jpg";